const objectToOptions = (object: { [key: string]: string }) =>
  Object.entries(object).map(([k, v]) => ({
    id: k,
    name: v,
  }))

export default objectToOptions
